import {bankLightningSvg as Icon__small__bankLightningSvg} from '../Icon__small/Icon__small--bankLightning.js';

export var bankLightning = {
  name: 'bankLightning',
  category: 'icon',
  colorable: true,
  svg: Icon__small__bankLightningSvg,
};
